import { LayoutPanelTop } from "lucide-react";

import BUTTON_TYPES from "@/lib/constants/buttonTypes";
import { SECTION_TYPES } from "@/lib/constants/sections";

import type { WebsiteWithImages } from "@/types/prisma";
import type { ServiceArea } from "@prisma/client";

const serviceAreaHeroSection = {
  type: SECTION_TYPES.SERVICE_AREA_HERO,
  content: {
    header: "Brief description of page content",
    subheader: "Elaborate on this particular service area page in a single paragraph.",
    bgImage: "", // optional
    showCustomButtons: false,
    buttons: [
      {
        type: BUTTON_TYPES.SITE_LINK,
        label: "Get in touch",
        link: "/contact-us",
      },
      {
        type: BUTTON_TYPES.EXTERNAL_LINK,
        label: "Find us here too",
        link: "https://google.com",
      },
    ],
  },
  meta: {
    displayName: "Service Area Page Intro",
    displayDescription: "Introduce your business to customers in this service area.",
    displayIcon: LayoutPanelTop,
  },
  aiPrompt(serviceArea: ServiceArea, website: WebsiteWithImages) {
    return `The goal here is to generate content for our service area page and rank for queries like "{industry} near me" or "{industry} near {city}, {state}". 
    Our location: "${serviceArea.name}". Please create an SEO-optimized h1 header and subheader. 
    The header should be brief text that includes the service area name + industry: "${serviceArea.name} ${website.industry}" 
    Keep it as brief as possible. E.g. if the industry is "Cleaning / Maid services" you could just say "cleaning services". 
    The subheader should elaborate on the unique selling points and benefits of the service area.
    
    As for the background image (bgImage) field, please set the value to this URL exactly: ${serviceArea.coverPhoto}`;
  },
};

export default serviceAreaHeroSection;
